module.exports = __webpack_public_path__ + "img/LP_JAGOPACK_Q1-2022_TACTICAL_Genesis.76e60413.jpg";